import React, { useContext, useMemo } from "react";
import { get } from "../../utils/helpers";
import useT from "../../hooks/useT";
import LanguageSwitcher from "../../components/LanguageSwitcher";
import { CustomerPageContext } from "../CustomerPage";
import { AppStateContext } from "../App";

export default function CustomerLanguageSwitcher() {
  // Shared context
  const { i18n } = useT();
  const [appState] = useContext(AppStateContext);
  const [customerPage, doCustomerPageAction] = useContext(CustomerPageContext);
  const config = appState.config;

  // Memoized values
  const languages = useMemo(() => {
    if (config.customise.languageSwitcher.showOnlyZoneLanguages) {
      return get(config, ["zones", appState.zone, "supportedLanguages"]);
    } else {
      return get(config, "languages.supportedLanguages");
    }
  }, [appState.zone]);

  const sort: boolean = get(config, "languages.sort");

  // Event handlers
  const handleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const newLanguage = event.target.value;
    if (newLanguage !== customerPage.language) {
      i18n.changeLanguage(newLanguage).then(() => {
        doCustomerPageAction({
          action: "setLanguage",
          payload: newLanguage
        });
      });
    }
  };

  return (
    <LanguageSwitcher
      id="customer-language-switcher"
      currentLanguage={customerPage.language}
      stepForm={customerPage.step}
      languages={languages}
      sortOptions={sort}
      onChange={handleChange}
    />
  );
}
